var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxoutlinemove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(2.15 1.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(2.15 8.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(2.15 4.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(7.05 1.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(7.05 8.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.4C0 0.626801 0.626801 0 1.4 0C2.1732 0 2.8 0.626801 2.8 1.4C2.8 2.1732 2.1732 2.8 1.4 2.8C0.626801 2.8 0 2.1732 0 1.4Z",
    transform: "translate(7.05 4.6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxoutlinemove);
export default __webpack_public_path__ + "static/media/vuesaxoutlinemove.0f7992c6abd85df8b2f88388ebe11f9a.svg";
export { ForwardRef as ReactComponent };